
import { getStorage } from '~/services/storage';

export default {
    name: 'GroupItem',
    props: {
        /**
         * A group object
         */
        group: {
            type: Object,
            required: true,
        },
    },
    methods: {
        async joinGroup() {
            if (!this.$store.state.auth.loggedIn) {
                this.$router.push({ name: getStorage('loginConverted') ? 'user-login' : 'user-register', query: { wastewarrior: true } });
                return;
            }
            const { message } = await this.$axios.$put(`${this.$config.endpoints.group}/${this.group.slug}/join`);
            this.$store.dispatch('setFlashMessage', { message });
            /* eslint vue/no-mutating-props: 0 */
            // @todo fix this
            this.group.is_member = true;
            this.group.users_count += 1;
        },
    },
};
